import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import OptionCard from '../shared/OptionCard/OptionCard';

class OptionCardField extends PureComponent {
  static propTypes = {
    className: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ).isRequired,
    optionsLabel: PropTypes.string,
    optionsActionMap: PropTypes.object.isRequired
  };

  onChange = selected => {
    const value = selected && selected.value;

    this.props.input.onChange(value);
  };

  render() {
    const { className, input, optionsActionMap, optionsLabel, options, meta } = this.props;
    const { value } = input;

    const errorMessage = meta.touched && meta.error ? meta.error : null;

    return (
      <React.Fragment>
        <OptionCard
          className={className}
          options={options}
          optionsLabel={optionsLabel}
          optionsActionMap={optionsActionMap}
          selectedOption={value}
          onChangeOption={this.onChange}
          errorMessage={errorMessage}
        />
      </React.Fragment>
    );
  }
}

export default OptionCardField;
